import { Creator, Timestamps } from '../interfaces';

export enum Status {
  ACTIVE = 'active',
  POTENTIAL = 'potential',
  NO_POTENTIAL = 'no_potential',
  ACTIVE_NON_OWNER = 'active_non_owner',
}

type Sector = {
  id: number;
  name: string;
  hasRooms: boolean;
  hasMealPlan: boolean;
  parentId: number;
};

type Island = {
  id: number;
  name: string;
};

type Group = {
  id: number;
  name: string;
  parentId: number;
};

type Agent = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
};

type Contact = {
  id: number;
  firstName: string;
  lastName: string;
};

type MealPlan = {
  id: number;
  name: string;
};

type Product = {
  id: number;
  name: string;
};

export type Area = {
  id: number;
  name: string;
};

export type Client = {
  id: number;
  name: string;
  status: Status;
  sector: Sector;
  group?: Group;
  island: Island;
  area?: Area;
  numberOfRooms: number | undefined;
};

export type ClientRetentionEntry = {
  id: number;
  name: string;
  status: Status;
  sector: Sector;
  group?: Group;
  daysLeft?: number;
  dueDate?: string;
  lastContactDate?: string;
  potentialProducts: Product[] | undefined;
  contractedProducts: Product[] | undefined;
};

export type ClientDetails = Client &
  Timestamps & {
    mealPlan: MealPlan[];
    potentialProducts: Product[] | undefined;
    contractedProducts: Product[] | undefined;
    contacts: Contact[];
    responsibleAgents: Agent[];
    createdBy: Creator;
    contactInterval: number | undefined;
  };

export type ClientsSort = {
  field: 'name' | 'numberOfRooms';
  sort: 'asc' | 'desc';
};

export type ClientRetentionOverviewSort = {
  field:
    | 'name'
    | 'next_contact'
    | 'last_contact'
    | 'group'
    | 'status'
    | 'responsible_agents';
  sort: 'asc' | 'desc';
};

export interface IGetClientsParams {
  page: number;
  perPage: number;
  sort?: string;
  search?: string;
}

export interface IGetClientsResponse {
  data: Client[];
  meta: {
    currentPage: number;
    lastPage: number;
    perPage: number;
    total: number;
  };
}

export interface IGetClientResponse {
  data: ClientDetails;
}

export interface ICreateClientParams {
  name: string;
  status: Status;
  sectorId: number;
  islandId: number;
  groupId?: number | string;
  numberOfRooms?: number;
  mealPlans?: number[];
  potentialProducts?: Array<number | string>;
  contractedProducts?: Array<number | string>;
  responsibleAgentId?: number;
  contacts?: number[];
  contactInterval?: number;
}

export type ClientListOption = {
  id: number;
  name: string;
};

export interface IGetClientsListResponse {
  data: ClientListOption[];
}
